(() => {
  if (window.green24VariantSyncInitialized) return;
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const replaceFromVariantHtml = (currentRoot, incomingRoot, selector) => {
    const current = currentRoot.querySelector(selector);
    const incoming = incomingRoot.querySelector(selector);

    if (!current || !incoming) return;
    current.replaceWith(incoming.cloneNode(true));
  };

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data?.sectionId || !data.html) return;

    const rootId = `ProductInfo-${data.sectionId}`;
    const currentRoot = document.getElementById(rootId);
    const incomingRoot = data.html.getElementById(rootId) || data.html.querySelector('product-info');

    if (!currentRoot || !incomingRoot) return;
    if (!currentRoot.querySelector('.green24-product-template-marker')) return;

    replaceFromVariantHtml(currentRoot, incomingRoot, '[data-green24-ean]');
    replaceFromVariantHtml(currentRoot, incomingRoot, '[data-green24-pack-facts]');
    replaceFromVariantHtml(currentRoot, incomingRoot, '[data-green24-buybox-footer]');

    const currentProduct = currentRoot.closest('product-info');
    const incomingProduct = incomingRoot.closest('product-info');
    if (currentProduct && incomingProduct) {
      replaceFromVariantHtml(currentProduct, incomingProduct, '#G24HydroCore-15944237252992 .g24-hydro__pack');
    }
  });

  window.green24VariantSyncInitialized = true;
})();
